import {HttpAxiosRequest} from "src/http/httpAxiosBase";
import {UserProfile} from "../../../../types/user/profile/profileData";

export const HttpCacheProfile = {
    getEndpoint: (url: string) => `cache/perfil${url}`,

    getProfileList: (): Promise<UserProfile[]> => {
        return HttpAxiosRequest.get(
            HttpCacheProfile.getEndpoint("")
        );
    },
}